<template>
  <b-table
    :items="tasks"
    :fields="columns"
    hover
    striped
    responsive
    show-empty
    class="cursor-pointer"
    @row-clicked="(item, _, __) => $emit('open', item)"
  >
    <template #head()="{ label }">
      <span class="text-capitalize">{{ label }}</span>
    </template>

    <template #cell(title)="data">
      <div class="text-truncate">
        <span v-b-tooltip.right.hover="data.item.title">
          {{ data.item.title }}
        </span>
      </div>

      <div class="d-flex align-items-center">
        <!-- Milestone -->
        <div
          v-if="data.item.milestone"
          class="d-flex align-items-center my-50 mr-1"
        >
          <feather-icon
            icon="CrosshairIcon"
            class="mr-50"
          />
          <small class="text-secondary">{{ data.item.milestone.name }}</small>
        </div>

        <!-- Labels -->
        <b-badge
          v-for="label in data.item.labels"
          :key="label.uuid"
          :style="{ backgroundColor: label.color}"
          class="mr-1"
        >
          {{ label.name }}
        </b-badge>
      </div>
    </template>

    <template #cell(assignee)="data">
      <div class="d-flex align-items-center">
        <b-avatar
          :src="getStorage(data.item.assignee?.avatar)"
          :text="data.item.assignee ? getInitials(data.item.assignee?.name) : ''"
        >
          <feather-icon
            v-if="!data.item.assignee"
            icon="UserIcon"
          />
        </b-avatar>
        <span class="ml-1">{{ data.item.assignee?.name || 'Unassigned' }}</span>
      </div>
    </template>

    <template #cell(dueDate)="{ item }">
      <span v-if="item.dueDate">{{ FORMAT_DATE(item.dueDate, 'DD MMM, YYYY') }}</span>
      <span v-else>-</span>
    </template>

    <template #cell(actions)="{ item }">
      <task-dropdown-actions
        :task="item"
        @edit="$emit('edit', item)"
        @refresh="$emit('fetch-board')"
      />
    </template>
  </b-table>
</template>

<script>
import { BTable, BAvatar, BBadge } from 'bootstrap-vue'
import TaskDropdownActions from './TaskDropdownActions.vue'

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    TaskDropdownActions,
  },
  props: {
    tasks: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      columns: [
        { key: 'title', label: this.$t('Title'), tdClass: 'w-50' },
        { key: 'assignee', label: this.$t('Assignee') },
        { key: 'dueDate', label: this.$t('Due Date') },
        { key: 'actions', label: this.$t('Actions') },
      ],
    }
  },
}
</script>
